import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "shadow rounded-4 overflow-hidden",
  style: {"width":"90%","max-width":"500px","margin-top":"35vh","margin-bottom":"10vh","margin-left":"2vw"}
}
const _hoisted_2 = { class: "card-body p-2 fondo-terciario" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-column align-items-center m-0 p-1 gap-2",
  role: "alert"
}
const _hoisted_4 = { class: "m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "card-header d-flex align-items-center justify-content-center bg-goethe-accent",
        style: {"height":"25px"}
      }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        ($setup.message!='')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString($setup.message), 1),
              ($setup.redirect)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "btn bg-goethe-accent texto-principal",
                    to: $setup.redirect,
                    style: {"height":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('volver')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}